import gql from "graphql-tag";

export const ARTICLE_QUERY = gql`
query Article1($locale: I18NLocaleCode, $articleId: ID) {
  article(locale: $locale, id: $articleId) {
    id
    attributes {
      createdAt
      updatedAt
      url
      header {
        title
        description
        articletype
        article_categories {
          data {
            id
            attributes {
                Title
                CategoryDescription
                sortorder
                visible
            }
          }
        }
        thumbnail {
          data {
            attributes {
              url
            }
          }
        }
        heroimage {
          data {
            attributes {
              url
            }
          }
        }
      }
      localizations {
        data {
          attributes {
            locale
            header {
              title
              description
              articletype
              article_categories {
                data {
                  id
                  attributes {
                      Title
                      CategoryDescription
                      sortorder
                      visible
                  }
                }
              }
              thumbnail {
                data {
                  attributes {
                    url
                  }
                }
              }
              heroimage {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
            content {
              __typename
              ... on ComponentArticleComponentsParagraph {
                paragraphText: text
                variant
              }
              ... on ComponentArticleComponentsSubheading {
                subheadingText: text
              }
              ... on ComponentArticleComponentsVideo {
                videoUrl: url
                videoLength: length
              }
              ... on ComponentArticleComponentsImageFullWidth {
                image {
                  data {
                    attributes {
                      alternativeText
                      caption
                      url
                    }
                  }
                }
              }
            }
            ExternalLinks {
              label
              link
            }
          }
        }
      }
      content {
          __typename
          ... on ComponentArticleComponentsParagraph {
            paragraphText: text
            variant
          }
          ... on ComponentArticleComponentsSubheading {
            subheadingText: text
          }
          ... on ComponentArticleComponentsVideo {
            videoUrl: url
            videoLength: length
          }
          ... on ComponentArticleComponentsImageFullWidth {
            image {
              data {
                attributes {
                  alternativeText
                  caption
                  url
                }
              }
            }
          }
      }
      suggestedArticles {
        data {
          id
          attributes {
            url
            header {
              title
              description
              articletype
              thumbnail {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
      }
      ExternalLinks {
        label
        link
      }
    }
  }
}
`;

export const ARTICLE_QUERY_BY_URL = gql`
query Article2($locale: I18NLocaleCode, $url: String!) {
  article(locale: $locale, url: $url) {
    id
    attributes {
      createdAt
      updatedAt
      url
      header {
        title
        description
        articletype
        thumbnail {
          data {
            attributes {
              url
            }
          }
        }
        heroimage {
          data {
            attributes {
              url
            }
          }
        }
      }
      content {
          __typename
          ... on ComponentArticleComponentsParagraph {
            paragraphText: text
            variant
          }
          ... on ComponentArticleComponentsSubheading {
            subheadingText: text
          }
          ... on ComponentArticleComponentsVideo {
            videoUrl: url
            videoLength: length
          }
          ... on ComponentArticleComponentsImageFullWidth {
            image {
              data {
                attributes {
                  alternativeText
                  caption
                  url
                }
              }
            }
          }
      }
      suggestedArticles {
        data {
          id
          attributes {
            url
            header {
              title
              description
              articletype
              thumbnail {
                data {
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
      }
      ExternalLinks {
        label
        link
      }
    }
  }
}
`;

export default ARTICLE_QUERY;

export const PREFETCH_QUERY = gql`
query Articles {
  articles(pagination: {limit: -1}) {
    data {
      id
      attributes {
        createdAt
        updatedAt
        sortorder
        url
        locale
        base_article {
          data {
            id
          }
        }
        restrictions {
          app_bundles {
            data {
              attributes {
                name
                bundle_id
              }
            }
          }
          tenancies {
            data {
              attributes {
                name
                identifier
              }
            }
          }
          careplans {
            data {
              attributes {
                title
                careplanIdentifier
              }
            }
          }
        }
        exclusions {
          app_bundles {
            data {
              attributes {
                name
                bundle_id
              }
            }
          }
          tenancies {
            data {
              attributes {
                name
                identifier
              }
            }
          }
          careplans {
            data {
              attributes {
                title
                careplanIdentifier
              }
            }
          }
        }
        localizations {
          data {
            attributes {
              locale
              header {
                title
                description
                articletype
                article_categories {
                  data {
                    id
                    attributes {
                        Title
                        CategoryDescription
                        sortorder
                        visible
                    }
                  }
                }
                thumbnail {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                heroimage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
              content {
                __typename
                ... on ComponentArticleComponentsParagraph {
                  paragraphText: text
                  variant
                }
                ... on ComponentArticleComponentsSubheading {
                  subheadingText: text
                }
                ... on ComponentArticleComponentsVideo {
                  videoUrl: url
                  videoLength: length
                }
                ... on ComponentArticleComponentsImageFullWidth {
                  image {
                    data {
                      attributes {
                        alternativeText
                        caption
                        url
                      }
                    }
                  }
                }
              }
              ExternalLinks {
                label
                link
              }
            }
          }
        }
        header {
          title
          description
          articletype
          article_categories {
            data {
              id
              attributes {
                  Title
                  CategoryDescription
                  sortorder
                  visible
              }
            }
          }
          thumbnail {
            data {
              attributes {
                url
              }
            }
          }
          heroimage {
            data {
              attributes {
                url
              }
            }
          }
        }
        content {
            __typename
            ... on ComponentArticleComponentsParagraph {
              paragraphText: text
              variant
            }
            ... on ComponentArticleComponentsSubheading {
              subheadingText: text
            }
            ... on ComponentArticleComponentsVideo {
              videoUrl: url
              videoLength: length
            }
            ... on ComponentArticleComponentsImageFullWidth {
              image {
                data {
                  attributes {
                    alternativeText
                    caption
                    url
                  }
                }
              }
            }
        }
        suggestedArticles {
          data {
            id
            attributes {
              url
              updatedAt
              restrictions {
                app_bundles {
                  data {
                    attributes {
                      name
                      bundle_id
                    }
                  }
                }
                tenancies {
                  data {
                    attributes {
                      name
                      identifier
                    }
                  }
                }
                careplans {
                  data {
                    attributes {
                      title
                      careplanIdentifier
                    }
                  }
                }
              }
              exclusions {
                app_bundles {
                  data {
                    attributes {
                      name
                      bundle_id
                    }
                  }
                }
                tenancies {
                  data {
                    attributes {
                      name
                      identifier
                    }
                  }
                }
                careplans {
                  data {
                    attributes {
                      title
                      careplanIdentifier
                    }
                  }
                }
              }
              header {
                title
                description
                articletype
                thumbnail {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
        substitutes {
          data {
            id
            attributes {
              sortorder
              restrictions {
                app_bundles {
                  data {
                    attributes {
                      name
                      bundle_id
                    }
                  }
                }
                tenancies {
                  data {
                    attributes {
                      name
                      identifier
                    }
                  }
                }
                careplans {
                  data {
                    attributes {
                      title
                      careplanIdentifier
                    }
                  }
                }
              }
              exclusions {
                app_bundles {
                  data {
                    attributes {
                      name
                      bundle_id
                    }
                  }
                }
                tenancies {
                  data {
                    attributes {
                      name
                      identifier
                    }
                  }
                }
                careplans {
                  data {
                    attributes {
                      title
                      careplanIdentifier
                    }
                  }
                }
              }
              url
              content {
                __typename
                ... on ComponentArticleComponentsParagraph {
                  paragraphText: text
                  variant
                }
                ... on ComponentArticleComponentsSubheading {
                  subheadingText: text
                }
                ... on ComponentArticleComponentsVideo {
                  videoUrl: url
                  videoLength: length
                }
                ... on ComponentArticleComponentsImageFullWidth {
                  image {
                    data {
                      attributes {
                        alternativeText
                        caption
                        url
                      }
                    }
                  }
                }
              }
              header {
                title
                description
                articletype
                article_categories {
                  data {
                    id
                    attributes {
                        Title
                        CategoryDescription
                        sortorder
                        visible
                    }
                  }
                }
                thumbnail {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
        ExternalLinks {
          label
          link
        }
      }
    }
  }
}
`;